import { constants } from "../constant/constants";
import ApiService from "../utils/ApiService";
import { getParsedNumber } from "../utils/Common";

export const storeCoupons = (coupons = []) => {
  localStorage.setItem("couponDropdown", JSON.stringify(coupons));
}

export const fetchAndstoreCoupons = async (restaurantId, token) => {
  const result = await ApiService.GET_COUPON_DROPDOWN(restaurantId, token);

  if (result.code === 200) {
    storeCoupons(result.payload.records);
  } else {
    storeCoupons([]);
  }
};

export const getValidCoupons = () => {
  const storedCoupons = JSON.parse(localStorage.getItem("couponDropdown") || "[]");
  const currentTime = new Date().getTime();

  // 3. Filter the array to keep only valid, active items
  const activeCoupons = storedCoupons.filter((item) => {
    const validFromTime = new Date(item.validFrom).getTime();
    const validUntilTime = new Date(item.validUntil).getTime();

    // Keep it if current time is AFTER validFrom AND BEFORE validUntil
    return currentTime >= validFromTime && currentTime <= validUntilTime;
  });

  return activeCoupons.map(item => ({label: item.code, value: item.code, isDiscountInPercent: item.isDiscountInPercent}));
};

export const getCouponInfo = async(restaurantId, code, token, showNotification) => {
  const result = await ApiService.APPLY_COUPON({restaurantId, code}, token);

  if (result?.code !== 200) {
    showNotification(result.message);
    return {
      success: false,
      data: {}
    };
  }

  const record = result.payload.record;

  return {
    success: true,
    data: {
    couponId: record.id,
    couponCode: record.code,
    discount: getParsedNumber(record.discount.discount),
    isDiscountInPercent: record.discount.isDiscountInPercent,
    discountAmount: 0,
    maxDiscount: getParsedNumber(record.discount.maxDiscountAmount),
    minOrderAmount: getParsedNumber(record.minOrderAmount)
  }
  }
}

export const isMinAmountSatisfiedCoupon = (order, couponInfo) => {
  let comparableOrderPrice = getParsedNumber(order.discountApplicablePrice);

  const subtotal = order.isVatIncluded ? getParsedNumber(order.totalPriceBeforeDiscount) : getParsedNumber(order.foodPriceBeforeDiscount);

  if (!couponInfo.isDiscountInPercent) {
    comparableOrderPrice = subtotal;
  }

  if (couponInfo.isDiscountInPercent && comparableOrderPrice === 0) {
    return `Coupon not applicable, order includes non-discountable items.`;
  }

  if (comparableOrderPrice < couponInfo.minOrderAmount) {
    return `Minimum order of ${couponInfo.minOrderAmount.toFixed(2)} TK required to apply this coupon`;
  }

  return "";
}

export const getApplicableDiscountInfoAccordingToMaxAmount = (discountApplicablePrice, discountAmount, couponInfo) => {
  let acutalDiscount = couponInfo.discount;

  const actualDiscountType = couponInfo.isDiscountInPercent
            ? constants.DISCOUNT_TYPE.PERCENTAGE
            : constants.DISCOUNT_TYPE.AMOUNT;

  if (!couponInfo.isDiscountInPercent) {
    return {
      acutalDiscount,
      actualDiscountType
    }
  }

  if (couponInfo.maxDiscount === 0 || discountAmount < couponInfo.maxDiscount) {
    return {
      acutalDiscount,
      actualDiscountType
    }
  }

  acutalDiscount = 100 * (couponInfo.maxDiscount / discountApplicablePrice);

  return {
    acutalDiscount,
    actualDiscountType
  }
}